<template>
  <div class="history-of-changes-list">
    <TirPmScrollbar class="history-of-changes-list__scroller" showOnHover @onScroll="onScoll">
      <div class="history-of-changes-list__content-list">
        <div class="history-of-changes-list__content-loading-spinner" v-if="!dataOfHistory">
          <TirPmSpinner></TirPmSpinner>
        </div>
        <HistoryOfChangesItem
          :historyItemData="itemHistory"
          v-for="itemHistory of dataOfHistory"
          :key="itemHistory.Id"
        /></div
    ></TirPmScrollbar>
  </div>
</template>

<!-- onScoll -->

<script setup lang="ts">
import HistoryOfChangesItem from './HistoryOfChangesItem.vue';

import { TirPmSpinner } from 'tir-pm-spinner';
import { onBeforeMount, onMounted, PropType, ref } from 'vue';
import { AdapterService } from './adapter';
import { TaskHistoryModel } from './models';
import { TirPmScrollbar } from 'tir-pm-scrollbar';

/**Параметры компонента */
const props = defineProps({
  /** Id задачи */
  taskId: { type: Number as PropType<number>, default: null },
});

const pageRequest = ref({
  Skip: 0,
  Take: 15,
});

/**Кол-во записей */
let countHistory: number | undefined;

/**
 *  Проверить проскроллен ли элемент до конца
 * @param element Элемент
 * @returns
 */

const checkScrolledToBottom = (element: HTMLElement): boolean =>
  element.scrollTop + element.clientHeight >= element.scrollHeight;

/**При скролле */
const onScoll = (event: any) => {
  const target = event.target as HTMLElement | undefined;
  if (
    !target ||
    !checkScrolledToBottom(target) ||
    isLoadingMore.value ||
    pageRequest.value.Skip >= countHistory
  )
    return;

  getTaskHistory();
};

const adapter = new AdapterService();

const dataOfHistory = ref<Array<TaskHistoryModel>>([]);
const isLoadingMain = ref(false);
const isLoadingMore = ref(false);

/**Запрос за компонентом */
const getTaskHistory = async () => {
  isLoadingMain.value = true;
  if (props.taskId) {
    const resp = await adapter.getTaskHistory(props.taskId, pageRequest.value);
    isLoadingMain.value = false;
    if (!resp.IsSuccess) return;

    dataOfHistory.value.push(...resp.Value.Items);
    pageRequest.value.Skip += resp.Value.Page.Size;
    countHistory = resp.Value.Page.Count;
  }
};

onMounted(() => {
  // adapter.subscribeGetTaskHistory();
});

onBeforeMount(async () => {
  await getTaskHistory();
});
</script>

<style lang="scss">
@import './style.scss';
</style>
